import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrderDetail,
  getPatientOrderDetail,
} from "../../actions/orderAction";
import {
  getHistoryPrescriptionForPractitioner,
  getOrderedPrescription,
} from "../../actions/prescriptionAction";
import { formatDate, getRoundPrice } from "../../utils/helper";
import PatientOrderDetail from "../PatientOrder/PatientOrderDetail";
import OrderDetail from "./OrderDetail";

const Invoice = ({ invoiceId, backAction, activeInvoice }) => {
  const dispatch = useDispatch();
  const orderDetail = useSelector((state) => state.order.orderDetail);
  const role = useSelector((state) => state.role.role);
  const [activeID, setActiveId] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (role.val == 3) {
      dispatch(
        getPatientOrderDetail(invoiceId, () => {
          setIsLoading(false);
        })
      );
    } else {
      dispatch(
        getOrderDetail(invoiceId, () => {
          setIsLoading(false);
        })
      );
    }
  }, []);
  const setActive = (id) => {
    setActiveId(id);
    if (role.val == 3) {
      dispatch(
        getOrderedPrescription(id, () => {
          setShowPopup(true);
        })
      );
    } else {
      dispatch(
        getHistoryPrescriptionForPractitioner(id, () => {
          setShowPopup(true);
        })
      );
    }
  };
  return (
    <>
      <button className="btn-orange mb-2" onClick={() => backAction(false)}>
        back
      </button>

      {showPopup &&
        (role.val == 3 ? (
          <PatientOrderDetail
            closePopup={() => setShowPopup(false)}
            prescriptionId={activeID}
            isRefill={false}
          />
        ) : (
          <OrderDetail
            closePopup={() => setShowPopup(false)}
            prescriptionId={activeID}
            isRefill={false}
          />
        ))}
      <div className="receipt-content">
        <div className="row">
          <div className="col-md-12">
            <div className="invoice-wrapper">
              <div className="payment-info">
                <div className="row">
                  <div className="col-sm-6">
                    <span>Invoice</span>
                    {isLoading ? "" : <strong>#{orderDetail?.INVC_ID}</strong>}
                  </div>
                  <div className="col-sm-6 text-right">
                    <span>Payment Date</span>
                    {isLoading ? (
                      ""
                    ) : (
                      <strong>{formatDate(orderDetail?.INVC_Date)}</strong>
                    )}
                  </div>
                </div>
              </div>

              <div className="payment-details">
                {isLoading ? (
                  <p>Loading...</p>
                ) : (
                  <div className="row">
                    {activeInvoice.invoiceType == 1 && (
                      <>
                        {orderDetail?.INVC_Delivery_Method == 0 ? (
                          <>
                            {orderDetail.ShippingInfo[0] && (
                              <div className="col-sm-4">
                                <span>Ship To:</span>
                                <strong>
                                  {orderDetail.ShippingInfo[0]?.BS_Display}
                                </strong>
                                <p>
                                  {orderDetail.ShippingInfo[0]?.BS_First_Name}{" "}
                                  {orderDetail.ShippingInfo[0]?.BS_Last_Name}{" "}
                                  <br />
                                  {
                                    orderDetail.ShippingInfo[0]?.ADDR_Line_1
                                  }{" "}
                                  <br />
                                  {
                                    orderDetail.ShippingInfo[0]?.ADDR_Locality
                                  }, {orderDetail.ShippingInfo[0]?.ADDR_Region}{" "}
                                  {orderDetail.ShippingInfo[0]?.ADDR_Zip_Post}{" "}
                                  <br />
                                  Phone: {
                                    orderDetail.ShippingInfo[0]?.BS_Phone
                                  }{" "}
                                  <br />
                                  Email: {orderDetail.ShippingInfo[0]?.BS_Email}
                                  <br />
                                  Tracking Number:{" "}
                                  <a
                                    className="link-orange"
                                    target="_blank"
                                    href={
                                      orderDetail?.Shipping_Carrier == "USPS"
                                        ? `https://tools.usps.com/go/TrackConfirmAction_input?origTrackNum=${orderDetail?.SHIP_Tracking_Number}`
                                        : orderDetail?.Shipping_Carrier == "UPS"
                                        ? `https://www.ups.com/track?tracknum=${orderDetail?.SHIP_Tracking_Number}`
                                        : `https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${orderDetail?.SHIP_Tracking_Number}`
                                    }
                                  >
                                    {" "}
                                    {orderDetail?.SHIP_Tracking_Number}
                                  </a>
                                </p>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="col-sm-4">
                            <span>Pickup At:</span>
                            <strong>Sun Ten Laboratories</strong>
                            <p>
                              9250 Jeronimo Road <br />
                              Irvine, CA 92618 <br />
                              Phone: (800) 333-4372 <br />
                            </p>
                          </div>
                        )}
                      </>
                    )}

                    {orderDetail?.INVC_Payment_Method == 2 ? (
                      <>
                        {orderDetail.CreditCardInfo[0] && (
                          <>
                            {orderDetail.CreditCardInfo[0]?.BS_Display ? (
                              <div className="col-sm-4">
                                <span>Billed To:</span>
                                <strong>
                                  {orderDetail.CreditCardInfo[0]?.BS_Display}
                                </strong>
                                <p>
                                  {orderDetail.CreditCardInfo[0]?.BS_First_Name}{" "}
                                  {orderDetail.CreditCardInfo[0]?.BS_Last_Name}{" "}
                                  <br />
                                  {
                                    orderDetail.CreditCardInfo[0]?.ADDR_Line_1
                                  }{" "}
                                  <br />
                                  {orderDetail.CreditCardInfo[0]?.ADDR_Locality}
                                  , {orderDetail.CreditCardInfo[0]?.ADDR_Region}{" "}
                                  {orderDetail.CreditCardInfo[0]?.ADDR_Zip_Post}{" "}
                                  <br />
                                  Phone:{" "}
                                  {orderDetail.CreditCardInfo[0]?.BS_Phone}{" "}
                                  <br />
                                  Email:{" "}
                                  {orderDetail.CreditCardInfo[0]?.BS_Email}
                                </p>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="col-sm-4">
                              <span>Payment Method:</span>
                              <strong>
                                {orderDetail.CreditCardInfo[0]?.CC_Name_On_Card}
                              </strong>
                              <p>
                                Card Number: ************
                                {orderDetail.CreditCardInfo[0]?.CC_Last_4}{" "}
                                <br />
                                {/* Exp. Date: 02/2012 */}
                              </p>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="col-sm-4">
                          <span>Payment Method:</span>
                          <strong>Paid in Clinic</strong>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
              {activeInvoice.invoiceType == 1 && (
                <>
                  <div className="line-items">
                    <div className="headers">
                      <div className="col">Items</div>
                      <div className="col text-right weight">Weight</div>
                      <div className="col icon text-right">Details</div>
                      <div className="col text-right">Amount</div>
                    </div>
                    {isLoading ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="items">
                        {orderDetail?.InvoiceItems.map((x) => {
                          if (x.DescriptionInfo) {
                            return (
                              <>
                                <div className="row item">
                                  <div className="col desc">
                                    {x.INVI_Type == 1 ? (
                                      <>
                                        Prescription #{x.INVI_ID}
                                        {role.val != 3
                                          ? ` for 
                                ${x.DescriptionInfo[0]?.patient_name}`
                                          : ` from 
                                ${x.DescriptionInfo[0]?.practitioner_name}`}
                                        <br /> Preparation Method:{" "}
                                        {x.DescriptionInfo[0].prep_method_name}
                                      </>
                                    ) : (
                                      <>
                                        Purchase:{" "}
                                        {x.DescriptionInfo.productName}
                                      </>
                                    )}
                                  </div>
                                  <div className="col qty text-right weight">
                                    {x.INVI_Type == 1
                                      ? `${x.DescriptionInfo[0].weight} grams`
                                      : ""}
                                  </div>
                                  {x.INVI_Type == 1 ? (
                                    <div
                                      className="col icon text-right"
                                      onClick={() => setActive(x.INVI_ID)}
                                    >
                                      <FontAwesomeIcon
                                        icon={faFileAlt}
                                        size="3x"
                                      />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <div className="col amount text-right">
                                    {role.val == 3
                                      ? getRoundPrice(
                                          parseFloat(x.INVC_Price) +
                                            parseFloat(
                                              orderDetail?.InvoiceItems.find(
                                                (x) => x.INVI_Type == 3
                                              )?.INVC_Price
                                            )
                                        )
                                      : getRoundPrice(x.INVI_Price)}
                                  </div>
                                </div>
                              </>
                            );
                          }
                        })}
                      </div>
                    )}
                    {isLoading ? (
                      ""
                    ) : (
                      <div className="total text-right">
                        <div className="field">
                          Subtotal:{" "}
                          <span>
                            {role.val == 3
                              ? getRoundPrice(
                                  orderDetail?.InvoiceItems.filter(
                                    (x) =>
                                      x.INVI_Type == 1 ||
                                      x.INVI_Type == 0 ||
                                      x.INVI_Type == 3
                                  ).reduce(
                                    (sum, value) =>
                                      sum + parseFloat(value.INVC_Price),
                                    0
                                  )
                                )
                              : getRoundPrice(
                                  orderDetail?.InvoiceItems.filter(
                                    (x) => x.INVI_Type == 1 || x.INVI_Type == 0
                                  ).reduce(
                                    (sum, value) =>
                                      sum + parseFloat(value.INVI_Price),
                                    0
                                  )
                                )}
                          </span>
                        </div>

                        {orderDetail?.InvoiceItems?.some(
                          (item) => item.INVI_Type == 2
                        ) && (
                          <div className="field">
                            Total Commission :{" "}
                            <span>
                              {getRoundPrice(
                                orderDetail?.InvoiceItems.filter(
                                  (x) => x.INVI_Type == 2
                                ).reduce(
                                  (sum, value) =>
                                    sum + parseFloat(value.INVI_Price),
                                  0
                                )
                              )}
                            </span>
                          </div>
                        )}
                        {orderDetail?.InvoiceItems?.some(
                          (item) => item.INVI_Type == 3 && role.val != 3
                        ) && (
                          <div className="field">
                            Total Preparation Cost:{" "}
                            <span>
                              {role.val == 3
                                ? getRoundPrice(
                                    orderDetail?.InvoiceItems.filter(
                                      (x) => x.INVI_Type == 3
                                    ).reduce(
                                      (sum, value) =>
                                        sum + parseFloat(value.INVC_Price),
                                      0
                                    )
                                  )
                                : getRoundPrice(
                                    orderDetail?.InvoiceItems.filter(
                                      (x) => x.INVI_Type == 3
                                    ).reduce(
                                      (sum, value) =>
                                        sum + parseFloat(value.INVI_Price),
                                      0
                                    )
                                  )}
                            </span>
                          </div>
                        )}
                        {orderDetail?.InvoiceItems?.some(
                          (item) => item.INVI_Type == 4
                        ) && (
                          <div className="field">
                            Shipping:{" "}
                            <span>
                              {role.val == 3
                                ? getRoundPrice(
                                    orderDetail?.InvoiceItems.find(
                                      (x) => x.INVI_Type == 4
                                    )?.INVC_Price ?? 0
                                  )
                                : getRoundPrice(
                                    orderDetail?.InvoiceItems.find(
                                      (x) => x.INVI_Type == 4
                                    )?.INVI_Price ?? 0
                                  )}
                            </span>
                          </div>
                        )}
                        {orderDetail?.InvoiceItems?.some(
                          (item) => item.INVI_Type == 6
                        ) && (
                          <>
                            <div className="field">
                              Shipping :{" "}
                              <span>
                                {role.val == 3
                                  ? getRoundPrice(
                                      orderDetail?.InvoiceItems.find(
                                        (x) => x.INVI_Type == 6
                                      )?.INVC_Price
                                    )
                                  : getRoundPrice(
                                      orderDetail?.InvoiceItems.find(
                                        (x) => x.INVI_Type == 6
                                      )?.INVI_Price
                                    )}
                              </span>
                            </div>
                            <div className="field">
                              Promo Shipping Discount:{" "}
                              <span>
                                (
                                {role.val == 3
                                  ? getRoundPrice(
                                      orderDetail?.InvoiceItems.find(
                                        (x) => x.INVI_Type == 6
                                      )?.INVC_Price
                                    )
                                  : getRoundPrice(
                                      orderDetail?.InvoiceItems.find(
                                        (x) => x.INVI_Type == 6
                                      )?.INVI_Price
                                    )}
                                )
                              </span>
                            </div>
                          </>
                        )}
                        {orderDetail?.InvoiceItems?.some(
                          (item) => item.INVI_Type == 5
                        ) && (
                          <div className="field">
                            Promo Discount:{" "}
                            <span>
                              (
                              {role.val == 3
                                ? getRoundPrice(
                                    orderDetail?.InvoiceItems.find(
                                      (x) => x.INVI_Type == 5
                                    )?.INVC_Price
                                  )
                                : getRoundPrice(
                                    orderDetail?.InvoiceItems.find(
                                      (x) => x.INVI_Type == 5
                                    )?.INVI_Price
                                  )}
                              )
                            </span>
                          </div>
                        )}
                        {orderDetail?.InvoiceItems?.some(
                          (item) => item.INVI_Type == 8
                        ) && (
                          <div className="field">
                            Total Tax:{" "}
                            <span>
                              {role.val == 3
                                ? getRoundPrice(
                                    orderDetail?.InvoiceItems.reduce(
                                      (sum, item) => {
                                        return item.INVI_Type === 8
                                          ? sum + parseFloat(item.INVC_Price)
                                          : sum;
                                      },
                                      0
                                    ) ?? 0
                                  )
                                : getRoundPrice(
                                    orderDetail?.InvoiceItems.reduce(
                                      (sum, item) => {
                                        return item.INVI_Type === 8
                                          ? sum + parseFloat(item.INVI_Price)
                                          : sum;
                                      },
                                      0
                                    ) ?? 0
                                  )}
                            </span>
                          </div>
                        )}

                        <div className="field grand-total payment-details">
                          Total:{" "}
                          <span>{getRoundPrice(orderDetail?.INVC_Price)}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
              {activeInvoice.invoiceType == 7 && (
                <>
                  <div className="line-items">
                    <div className="headers">
                      <div className="col">Item</div>
                      <div className="col text-right">Amount</div>
                    </div>
                    {isLoading ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="items">
                        {orderDetail?.InvoiceItems.map((x) => {
                          return (
                            <>
                              <div className="row item">
                                <div className="col desc">
                                  {activeInvoice.detailText}
                                </div>
                                <div className="col amount text-right">
                                  {role.val == 3
                                    ? getRoundPrice(x.INVC_Price)
                                    : getRoundPrice(x.INVI_Price)}
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    )}
                    {isLoading ? (
                      ""
                    ) : (
                      <div className="total text-right">
                        <div className="field grand-total ">
                          Total:{" "}
                          <span>{getRoundPrice(orderDetail?.INVC_Price)}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Invoice;
